import { useFetch } from './useFetch';
import type { AsyncState } from './useFetch';
import { fetchAdminUsers } from '@/api/admin';
import type { AdminUsersQuery } from '@/api/admin';
import type { AdminUsersResponse } from '@/api/types';

export function useAdminUsers(query: AdminUsersQuery = {}): AsyncState<AdminUsersResponse> {
  const key = JSON.stringify(query);
  return useFetch<AdminUsersResponse>((signal) => fetchAdminUsers(query, signal), [key]);
}
